import { useAtomValue } from 'jotai';

import { Stack } from '@ekhodealer/ekho-common/rev';

import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { useGetOrderDetails } from '../../api/useGetOrderDetails';
import { orderDetailsDrawerAtom } from '../../atoms/orderDetailsDrawerAtoms';

import { SectionSkeleton } from './shared/SectionSkeleton';

const SECTION_TITLE = 'Registration details';

export const RegistrationDetailsSection = () => {
	const { selectedRow } = useAtomValue(orderDetailsDrawerAtom);
	const { data: orderDetails, isLoading } = useGetOrderDetails(
		selectedRow?.purchasedVehicleId || undefined,
	);

	if (isLoading) {
		return <SectionSkeleton title={SECTION_TITLE} />;
	}

	if (!orderDetails) {
		return null;
	}

	const { registrationDetails } = orderDetails;

	return (
		<AccordionSection title={SECTION_TITLE} defaultExpanded>
			<Stack itemsSpacing='12'>
				<InfoLineItem title='DMV workflow' value={registrationDetails.dmvWorkflow} />
				<InfoLineItem title='Use type' value={registrationDetails.useType} />
				<InfoLineItem
					title='Registration address'
					value={registrationDetails.registrationAddress}
					isCopyable
				/>
				<InfoLineItem
					title='Registration state'
					value={registrationDetails.registrationState}
				/>
			</Stack>
		</AccordionSection>
	);
};
